<template>
  <v-tooltip v-if="!fileExists" top>
    <template v-slot:activator="{ on, attrs }">
      <img
        :src="platformImageSrc"
        :alt="platformName"
        :key="platform"
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <span>{{ platformName }}'s icon is not found</span>
  </v-tooltip>
  <img v-else :src="platformImageSrc" :alt="platformName" :key="platform" />
</template>
<script>
import { PLATFORMS, PLATFORM_TYPES } from "../../constants";

export default {
  name: "PlatformLogo",
  PLATFORMS,
  PLATFORM_TYPES,
  props: {
    platform: {
      type: String,
      required: true,
      validator: (platform) => Object.values(PLATFORMS).includes(platform),
    },
  },
  computed: {
    fileExists() {
      try {
        require(`../../assets/images/platforms/${this.platform}.svg`);
        return true;
      } catch (e) {
        return false;
      }
    },
    platformImageSrc() {
      try {
        return require(`../../assets/images/platforms/${this.platform}.svg`);
      } catch (e) {
        return require("../../assets/images/icons/caution.svg");
      }
    },
    platformName() {
      const platformType = PLATFORM_TYPES.find((p) => p.id === this.platform);
      return platformType ? platformType.name : this.platform;
    },
  },
};
</script>
